//import Vue from 'vue';
import http from '../http'
import config from "../../configuration.json";
import router from '../router';
export default {
    namespaced: true,
    state: {
        emailRegistered: null,
        passwordRegistered: null,
        registerError: null,
        emailLogin: null,
        emailToolbar: null,
        passwordLogin: null,
        loginError: null,
        token: null,
        rememberLogin: null
    },

    actions: {
        getInfo({ commit, state }) {
            return http().get(`${config.API_URL}info`
            ).then(({ data }) => {
                commit('setEmailToolbar', data.email);
                commit('setEmailLogin', data.email);
                var temp = data;
                temp.trigger = Math.floor(Math.random() * 101);
                commit('setLoggedUser', JSON.stringify(temp));
            }).catch((err) => {
                commit('setLoggedUser', JSON.stringify({}));
                commit("setEmailToolbar", "Accedi");
                router.push('/');
            })
        },
        login({ commit, state }) {
            return http().post(`${config.API_URL}auth/login`, {
                email: state.emailLogin,
                password: state.passwordLogin,
                remember: state.rememberLogin
            }).then(({ data }) => {
                commit('setLoggedUser', JSON.stringify(data));
                commit("setErrorLogin", JSON.stringify({ "show": true, "message": data, "color": "green" }))
                router.push('/builder');
            }).catch((err) => {
                commit("setLoggedUser", JSON.stringify({}));
                commit("setEmailToolbar", "Accedi");
                commit("setErrorLogin", JSON.stringify({ "show": true, "message": err.response.data, "color": "red"}))
                router.push('/');
            })
        },
        register({ commit, state }) {
            return http().post('/auth/register', {
                email: state.emailRegistered,
                password: state.passwordRegistered
            }).then(({ data }) => {
                commit('setToken', data.token);
                commit("setErrorRegistered",null);
                router.push('/');
            }).catch(() => {
                commit("setErrorRegistered", 'invalid registration information');
            })
        },
        logout({ commit, state }) {
            return http().post(`${config.API_URL}auth/logout`, {
                email: state.emailLogin
            }).then(({ data }) => {
                commit("setLoggedUser", JSON.stringify({}));
                commit("setEmailToolbar", "Accedi");
                commit("setErrorLogin", JSON.stringify({ "show": true, "message": data, "color": "info" }))
                document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
                router.push('/');
            }).catch(() => {
                console.log("Cannot logout");
            })
        }
    },
    getters: {
        getEmailLogin(state){
            return state.emailLogin;
        },
        getLoggedUser(state) {
            return state.loggedUser;
        },
        getLoginError(state) {
            return state.loginError;
        }
    },
    mutations: {
        setEmailRegistered(state, email) {
            state.emailRegistered = email;
        },
        setPasswordRegistered(state, password) {
            state.passwordRegistered = password;
        },
        setErrorRegistered(state, error) {
            state.registerError = error;
        },
        setEmailLogin(state, email) {
            if(email.length > 50){
                state.emailLogin = email.substring(0,50);
            }
            else{
            state.emailLogin = email;
            }
        },
        setRememberLogin(state, remember) {
            state.rememberLogin = remember;
        },
        setLoggedUser(state, obj) {
            state.loggedUser = obj;
        },
        setPasswordLogin(state, password) {
            if (password.length > 20) {
                state.passwordLogin = password.substring(0, 20);
            }
            else {
                state.passwordLogin = password;
            }
        },
        setEmailToolbar(state, email) {
            state.emailToolbar = email;
        },
        setErrorLogin(state, error) {
            state.loginError = error;
        },
        setToken(state, token) { state.token = token; }
    },
}
